import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

export const kymw1317Handlers = [
  // 企画連絡の承認対象情報（アイテム）取得 /KYMW13/getApprovalItemList
  http.post(PlessService.SERVICE.getApprovalItemList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getApprovalItemListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 企画連絡の承認情報（アイテム）を反映 /KYMW13/approvalItem
  http.post(PlessService.SERVICE.approvalItem.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(approvalItemResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
]

const getApprovalItemListResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      CommonItem: {
        OrderCode: "2023440",
        PCode: "P2674495",
        GuideGoodsName: "ベルシーオ　薬用ブライトニングローション",
        GuideStandardName: "さっぱり　１５０ｍＬ×２",
        KikakuRenrakuStatus: "3 ",
        KikakuRenrakuStatusName: "予定承認待ち",
        KikakuRenrakuStatusBgColor: "255, 255, 153"
      },
      SupplierInformationList: [
        {
          ItemCode: "4470338",
          OrderClientName: "高千穂物産",
          KikakuRenrakuKakuninUserName: "",
          DataCreateDay: "",
          MessageFromClient: "",
          DisplayImageChangeIndication: "",
          HouzaiHenkouKanouseiAri: null,
          MessageFromCoop: ""
        }
      ],
      ApprovalColumnList: [
        {
          ItemCode: "4470338",
          Approver: "2",
          ReflectUnit: "P",
          ColumnNo: "002       ",
          ColumnName: "商品案内用商品名",
          PlanContactData: "2222",
          SupplierFixData: "1111",
          Current: "ベルシーオ　薬用ブライトニングローション",
          CodeDiv: "",
          CodeSeqNo: "",
          OperationType: "",
          UnreflectColumn: "",
          SkeweredConfig: "2",
          NgWord: ""
        },
        {
          ItemCode: "4470338",
          Approver: "2",
          ReflectUnit: "P",
          ColumnNo: "003       ",
          ColumnName: "商品案内用規格名",
          PlanContactData: "2222",
          SupplierFixData: "1111",
          Current: "さっぱり　１５０ｍＬ×２",
          CodeDiv: "",
          CodeSeqNo: "",
          OperationType: "",
          UnreflectColumn: "",
          SkeweredConfig: "2",
          NgWord: ""
        },
        {
          ItemCode: "4470338",
          Approver: "2",
          ReflectUnit: "P",
          ColumnNo: "004       ",
          ColumnName: "商品案内温度帯区分",
          PlanContactData: "",
          SupplierFixData: "1 ：",
          Current: "",
          CodeDiv: "",
          CodeSeqNo: "",
          OperationType: "",
          UnreflectColumn: "",
          SkeweredConfig: "0",
          NgWord: ""
        },
        {
          ItemCode: "4470338",
          Approver: "2",
          ReflectUnit: "P",
          ColumnNo: "005       ",
          ColumnName: "賞味期間",
          PlanContactData: "",
          SupplierFixData: "1",
          Current: "0",
          CodeDiv: "",
          CodeSeqNo: "",
          OperationType: "",
          UnreflectColumn: "",
          SkeweredConfig: "2",
          NgWord: ""
        },
        {
          ItemCode: "4470338",
          Approver: "2",
          ReflectUnit: "P",
          ColumnNo: "006       ",
          ColumnName: "消費期限",
          PlanContactData: "",
          SupplierFixData: "1",
          Current: "0",
          CodeDiv: "",
          CodeSeqNo: "",
          OperationType: "",
          UnreflectColumn: "",
          SkeweredConfig: "2",
          NgWord: ""
        }
      ]
    }
  }
}

const approvalItemResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      Parameter1: "パラメータ１",
      Parameter2: "",
      Parameter3: "",
      Parameter4: "",
      MessageID: ""
    }
  }
}